import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout' // 框架页面
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [ // 登录
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        title: '登录'
      }
    }, {
      path: '/fxs',
      name: 'fxs',
      component: () => import('@/views/fxs/index.vue'),
      meta: {
        title: '法信平台密码生成系统'
      }
    }, {
      path: '/',
      name: 'index',
      component: layout,
      redirect: '/login',
      meta: {
        title: '欢迎使用'
      },
      children: [{
        path: 'study/list',
        name: 'studyList',
        component: () => import('@/views/study/list.vue'),
        meta: {
          title: '课程列表'
        }
      }, {
        path: 'study/:id',
        name: 'studyDetail',
        component: () => import('@/views/study/detail.vue'),
        meta: {
          title: '课程详情'
        }
      }, {
        path: '/user/reset-password',
        name: 'resetPassword',
        component: () => import('@/views/user/resetPassword.vue'),
        meta: {
          title: '重置密码'
        }
      }, {
        path: '/user/base',
        name: 'userBaseInfo',
        component: () => import('@/views/user/baseInfo.vue'),
        meta: {
          title: '基本信息'
        }
      }, {
        path: '/user/history',
        name: 'userStudyHistory',
        component: () => import('@/views/user/history.vue'),
        meta: {
          title: '播放记录'
        }
      }, {
        path: 'admin/statistic',
        name: 'adminStatistic',
        component: () => import('@/views/admin/statistic/index.vue'),
        meta: {
          title: '学习进度统计'
        }
      }, {
        path: 'admin/create',
        name: 'adminCreate',
        component: () => import('@/views/admin/statistic/create.vue'),
        meta: {
          title: '添加用户'
        }
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js